import React from 'react'
import PropTypes from 'prop-types'
// hooks
import { useNavigate } from 'react-router-dom'

// components
import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
  CardHeader,
} from '@mui/material'

import { useIsMobileView } from '../../../../../../utils/isMobileView'
// constants

const handleButtonStyle = (style, isMobile) => {
  let buttonStyle
  if (style === 'submit') {
    buttonStyle = {
      backgroundColor: '#eb1700',
      width: '163px',
      marginBottom: isMobile ? '0' : '34px',
      marginTop: '24px',
      marginLeft: isMobile ? '0' : '30px',
      paddingleft: isMobile ? '0' : '30px',
      '&:hover': {
        backgroundColor: '#CC1400',
      },
      '&:disabled': {
        backgroundColor: '#665A47',
      },
      '&:focus': {
        backgroundColor: '#CC1400',
      },
    }
  }

  if (style === 'secondary') {
    buttonStyle = {
      backgroundColor: 'rgba(98, 81, 55, 0.1)',
      width: '163px',
      marginBottom: isMobile ? '0' : '34px',
      marginTop: isMobile ? '12px' : '24px',
      marginLeft: isMobile ? '0 !important' : '30px',
      paddingleft: isMobile ? '0' : '30px',
      color: '#000',
      '&:hover': {
        backgroundColor: 'rgba(102,90,71, 0.20)',
        color: '#000000',
      },
      '&:disabled': {
        backgroundColor: 'rgba(138, 115, 92, 0.05)',
      },
      '&:focus': {
        backgroundColor: 'rgba(112, 99, 79, 0.1)',
      },
    }
  }
  return buttonStyle
}

const renderButton = (link) => {
  const { label, path, btnClassName, shouldOpenInNewTab } = link
  const navigate = useNavigate()
  const isMobileView = useIsMobileView()
  return (
    <Button
      onClick={() => (shouldOpenInNewTab ? window.open(path) : navigate(path))}
      className={btnClassName}
      disableElevation
      sx={
        btnClassName === 'secondary-btn'
          ? handleButtonStyle('secondary', isMobileView)
          : handleButtonStyle('submit', isMobileView)
      }
      variant="contained"
    >
      {label}
    </Button>
  )
}

const renderButtons = (links = []) =>
  links.filter((link) => link.btnClassName !== 'secndary-btn').map(renderButton)

const MenuItem = ({ menuItem }) => {
  const { name, svg, text, list, links, id } = menuItem
  const isMobileView = useIsMobileView()

  return (
    <Card
      key={id}
      style={{
        height: 'auto',
        width: '415px',
        borderRadius: '1px',
        backgroundColor: 'white',
        position: 'relative',
        marginRight: isMobileView ? '10px' : '20px',
        marginLeft: isMobileView ? '10px' : '0',
        marginBottom: '20px',
        overflow: 'hidden',
        flexWrap: 'wrap',
        boxShadow: 'none',
        border: '1px solid #C1BBB3',
        display: 'flex',
        paddingBottom: isMobileView ? '0' : '58px',
      }}
    >
      <div style={{ paddingBottom: isMobileView ? '0' : '24px' }}>
        <CardHeader
          style={{ marginBottom: '0px', paddingBottom: '0px' }}
          title={(
            <Typography
              variant="h6"
              style={{
                fontFamily: 'Johnson Display',
                fontWeight: 'bold',
                fontSize: '28px',
              }}
            >
              <img
                style={{
                  width: '30px',
                  height: '30px',
                  marginTop: '10px',
                  verticalAlign: '-10%',
                  marginRight: '10px',
                  marginLeft: '30px',
                  paddingleft: '30px',
                }}
                src={svg}
                alt="icon"
              />
              {name}
            </Typography>
          )}
        />
        <CardContent
          style={{
            marginTop: '0px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
          }}
        >
          {/* <img src={svg} /> */}
          <Typography
            variant="h6"
            style={{
              fontSize: '16px',
              fontFamily: 'Johnson Text',
              marginLeft: '30px',
              marginRight: isMobileView ? '30px' : '0',
              paddingleft: '30px',
            }}
          >
            {text}
          </Typography>
          <Typography
            variant="h6"
            style={{
              fontSize: '16px',
              fontFamily: 'Johnson Text',
              marginLeft: '30px',
              marginRight: isMobileView ? '30px' : '0',
              paddingleft: '30px',
            }}
          >
            <ul
              style={{
                listStyle: 'none',
                padding: '0',
                margin: '0',
                marginLeft: '25px',
              }}
            >
              {list.map((item, index) => (
                <li
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  style={{
                    paddingleft: '1em',
                    textAlign: 'match-parent',
                    listStyleType: 'disc',
                  }}
                >
                  {item}
                </li>
              ))}
            </ul>
          </Typography>
        </CardContent>
      </div>
      <CardActions
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: isMobileView ? 'column' : 'row',
          width: '100%',
          position: isMobileView ? 'static' : 'absolute',
          bottom: 0,
          justifyContent: isMobileView ? 'center' : 'left',
          paddingBottom: isMobileView ? '24px' : '0'
        }}
      >
        {renderButtons(links)}
      </CardActions>
    </Card>
  )
}

MenuItem.propTypes = {
  menuItem: PropTypes.shape({
    name: PropTypes.string.isRequired,
    svg: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired,
    links: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
}

export default MenuItem
